import { render, staticRenderFns } from "./DueCreateFirstStep.vue?vue&type=template&id=20763ce3&scoped=true&"
import script from "./DueCreateFirstStep.vue?vue&type=script&lang=js&"
export * from "./DueCreateFirstStep.vue?vue&type=script&lang=js&"
import style0 from "./DueCreateFirstStep.vue?vue&type=style&index=0&id=20763ce3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20763ce3",
  null
  
)

export default component.exports